import { Button, IconButton, List, Stack, Typography } from "@mui/material"
import EditableText from "components/controls/input-hidden"
import { useDialogStore } from "dialogs"
import { action } from "mobx"
import { useMainStore } from "store"
import { increment, num } from "utils/lang"
import { useLocation } from "wouter"
import { Column, Header, SchemaListItem } from "./styled"
import { observer } from "mobx-react-lite"
import Content from "store/content"
import useKeyDown from "utils/use-key-down"

import ArrowBackIcon from "components/icons/base/back"
import AddIcon from "components/icons/editor/add"
import CopyIcon from "components/icons/editor/copy"
import DeleteIcon from "components/icons/editor/delete"
import LayersIcon from "components/icons/other/layers"
import SettingsIcon from "components/icons/other/settings"

const ContentList = observer(() => {

  const dialog = useDialogStore()
  const store = useMainStore()
  const project = store.projects.get(store.selectedProject!)!
  const [ , setLocation ] = useLocation()

  const deleteContentBlock = (content: Content) => {
    dialog.open("delete", { content: `Блок «${content.name}» будет удален`, onConfirm: () => {
      project.deleteContent(content.id)
      store.saveProject(project)
    } })
  }

  const dublicate = action((content: Content) => {
    const newContent = new Content(content.schemeId)
    const names = Array.from(project.contents.values()).map(item => item.name)
    newContent.name = increment(content.name, names)
    newContent.data.sectionId = content.data.sectionId
    newContent.data.values = JSON.parse(JSON.stringify(content.data.values))
    
    const entries = Array.from(project.contents.entries())
    const index = entries.findIndex(item => item[0] === content.id)
    entries.splice(index+1, 0, [ newContent.id, newContent ])
    project.contents.replace(entries)

    dialog.open("newContentBlock", { content: newContent, isCopy: true })
    // store.saveContent(newContent)
    // store.saveProject(project)
  })

  useKeyDown({
    "Escape": () => store.selectProject(null)
  })

  return (
    <Column sx={{ maxWidth: 600, bgcolor: "background.paper", ml: "auto", my: 5, borderRadius: "20px 0 0 20px" }}>
      <Header sx={{ px: 4, pt: 3 }}>
        <IconButton sx={{ ml: -1.2, mr: 1.5 }} onClick={() => store.selectProject(null)}>
          <ArrowBackIcon sx={{ fontSize: 20, color: 'text.secondary' }}/>
        </IconButton>
        <EditableText 
          value={project.name || ""} 
          onChange={action(e => project.name = e.target.value)}  
          sx={{ fontSize: 24, fontWeight: 700 }}
          placeholder="Название сайта"
        />
      </Header>
      <Stack sx={{ px: 8.95, mt: -0.8, mb: 2, height: 26 }}>
        <EditableText 
          value={project.slug || ""} 
          onChange={action(e => project.slug = e.target.value)}  
          sx={{ fontSize: 14, fontWeight: 600, color: "text.secondary" }} 
          placeholder="Без slug"
        />
      </Stack>
      <Stack sx={{ px: 4, pb: 2 }} direction="row" alignItems="center">
        <Stack spacing={0.4}>
          <Typography fontWeight={700} fontSize={14}>Созданные блоки</Typography>
          <Typography color="text.secondary">
            { num(project.contents.size, "блок", "блока", "блоков") }
          </Typography>
        </Stack>
        <Button variant="contained" sx={{ ml: "auto" }} onClick={() => dialog.open("newContentBlock")}>
          <AddIcon sx={{ mr: 1, fontSize: 16 }}/>
          Добавить блок
        </Button>
      </Stack>
      <List disablePadding>
        { Array.from(project.contents.values()).map(item => (
          <SchemaListItem 
            key={item.id}
            sx={{ px: 4 }} 
            onClick={e => e.target === e.currentTarget && setLocation(`/content/${project.id}-${item.id}`) }
          >
            <LayersIcon sx={{ fontSize: 22, mr: 2.5, color: "text.secondary", pointerEvents: "none" }}/>
            <Stack sx={{ mr: "auto", pointerEvents: "none" }}>
              <Typography fontWeight={700}>
                { item.name || "Без названия" }
              </Typography>
              <Typography color="text.secondary">
                { store.schemes.get(item.schemeId)?.data.name || "Без схемы" }
              </Typography>
            </Stack>
            <IconButton 
              onClick={() => dialog.open("newContentBlock", { content: item })}
              sx={{ ml: 1.5, color: "primary.main", bgcolor: "background.default" }} 
              className="show-on-hover"
            >
              <SettingsIcon/>
            </IconButton>
            <IconButton 
              onClick={() => dublicate(item)}
              sx={{ ml: 1.5, color: "primary.main", bgcolor: "background.default" }} 
              className="show-on-hover"
            >
              <CopyIcon/>
            </IconButton>
            <IconButton
              onClick={() => deleteContentBlock(item)}
              sx={{ ml: 1.5, color: "primary.main", bgcolor: "background.default" }} 
              className="show-on-hover"
            >
              <DeleteIcon />
            </IconButton>
          </SchemaListItem>
        ))}
      </List>
    </Column>
  )
})

export default ContentList